import { apiStudent } from '@/lib/api-manager'

export async function approveRequest(requestId?: string) {
  return await apiStudent.patch(`v1/requests/request/${requestId}/approve`)
}
